import { render, staticRenderFns } from "./form_assignment_template_component.vue?vue&type=template&id=7f620aa0&scoped=true"
import script from "./form_assignment_template_component.vue?vue&type=script&lang=js"
export * from "./form_assignment_template_component.vue?vue&type=script&lang=js"
import style0 from "./form_assignment_template_component.vue?vue&type=style&index=0&id=7f620aa0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f620aa0",
  null
  
)

export default component.exports